// 产品管理
import http from "@/jslibs/axios/http";

// 新增产品
export const add = (data) => http.post("/cms/product/add", data);

// 编辑产品
export const edit = (data) => http.post("/cms/product/update", data);

// 产品状态批量修改
export const updateStatus = (data) => http.post("/cms/product/updateStatus", data);

// 产品详情
export const detail = (id) => http.get("/cms/product/details/" + id);

// 产品全量列表
export const list = (data) => http.get("/cms/product/list", data);

// 产品分页列表
export const page = (data) => http.get("/cms/product/page", data);

// 产品删除
export const del = (id) => http.delete("/cms/product/" + id);

// 产品导入模板
export const excelStencil = () => http.post("/cms/product/excelStencil", {}, { responseType: "blob" });

// 产品导出
export const excel = (data) => http.post("/cms/product/excel", data, { responseType: "blob" });

// 产品导入
export const importExcel = ({ file }) => {
    const params = new FormData();
    params.append("file", file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post("/cms/product/importExcel", params, config);
};